import dayjs from 'dayjs'

export const displayDateAsText = (date: string | null | undefined | Date, format: string): string | null => {
  if (!date) return null
  const parsed = dayjs(date)
  if (!parsed.isValid()) return null

  return parsed.format(format)
}
